var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { opacity: 1;fill: #828282 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m9 13.2c-5.6 0-9-6.2-9-6.2 0 0 3.4-6.2 9-6.2 5.6 0 9 6.2 9 6.2 0 0-3.4 6.2-9 6.2zm-7.7-6.2q0.8 1.2 1.9 2.3c1.4 1.4 3.4 2.8 5.8 2.8 2.4 0 4.4-1.4 5.8-2.8 0.7-0.7 1.3-1.4 1.7-2q0.1-0.2 0.2-0.3-0.8-1.2-1.9-2.3c-1.4-1.4-3.4-2.8-5.8-2.8-2.4 0-4.4 1.4-5.8 2.8q-1.1 1.1-1.9 2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m5.1 7c0-1 0.4-2 1.1-2.8 0.8-0.7 1.8-1.1 2.8-1.1 1 0 2 0.4 2.8 1.1 0.7 0.8 1.1 1.8 1.1 2.8 0 1-0.4 2-1.1 2.8-0.8 0.7-1.8 1.1-2.8 1.1-1 0-2-0.4-2.8-1.1-0.7-0.8-1.1-1.8-1.1-2.8zm3.9-2.8c-0.7 0-1.5 0.3-2 0.8-0.5 0.5-0.8 1.3-0.8 2 0 0.7 0.3 1.5 0.8 2 0.5 0.5 1.3 0.8 2 0.8 0.7 0 1.5-0.3 2-0.8 0.5-0.5 0.8-1.3 0.8-2 0-0.7-0.3-1.5-0.8-2-0.5-0.5-1.3-0.8-2-0.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.5b24fbcd851f3fe9e449a5a623914734.svg";
export { ForwardRef as ReactComponent };